import Image from "next/image";
import Link from "next/link";

export default function PageFooter() {
  return (
    <footer className="bg-brand-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-lg p-8 mb-12 border border-blue-500/30">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold mb-3">What's a Missed Call Really Costing You?</h3>
              <p className="text-slate-300 mb-4">Use our calculator to discover how much revenue you're losing every year to voicemail, busy signals, and unanswered calls.</p>
              <Link href="/human-vs-ai/the-cost-of-missed-calls" className="inline-block bg-brand-red hover:bg-opacity-90 text-white font-bold px-6 py-3 rounded transition">
                Try the Calculator →
              </Link>
            </div>
            <div className="bg-slate-900/50 p-6 rounded-lg border border-slate-700 text-center">
              <p className="text-slate-400 text-sm mb-2">Average Annual Loss</p>
              <p className="text-4xl font-black text-red-500">$150K+</p>
              <p className="text-xs text-slate-500 mt-2">for businesses missing just 10 calls/week</p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <p className="text-lg mb-4">
              In business since 1967, AnswerOne is the most experienced answering service in the
              New York area.
            </p>
            <p className="text-lg italic">
              We do more than answer the phones, "we make you and your company look good."
            </p>
          </div>

          <div className="text-center">
            <Image
              src="/images/logo.svg"
              alt="AnswerOne logo"
              width={404}
              height={50}
              className="mx-auto mb-4 h-12 w-auto"
              loading="lazy"
            />
            <p className="mb-2">7014 13th Avenue, Brooklyn NY 11228</p>
            <p className="mb-4">+1 (718) 748-8888 phone</p>
            <div className="flex justify-center gap-4 flex-wrap">
              <Link href="/features" className="hover:underline">Features</Link>
              <Link href="/resources" className="hover:underline">Resources</Link>
              <Link href="/terms-conditions" className="hover:underline">Terms & Conditions</Link>
              <Link href="/privacy-policy" className="hover:underline">Privacy Policy</Link>
            </div>
          </div>

          <div className="md:text-right">
            <div className="mb-4 flex flex-col items-center md:items-end gap-4">
              <a href="https://www.showmelocal.com/profile.aspx?bid=15328719" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://www.showmelocal.com/showmelocal-member-15328719" 
                  style={{ width: '150px' }} 
                  alt="AnswerOne, Inc.,Telephone Answering Service,Brooklyn,NY"
                  loading="lazy"
                  width={150}
                  height={50}
                />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center text-sm text-slate-400">
          <p className="mb-2">AnswerOne® is a registered trademark of AnswerOne Inc.</p>
          <p>© Copyright 2026. AnswerOne Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
